import React from 'react';

import PropTypes from 'prop-types';

import {
    LongFormContent,
    PageSection,
    PageTitle,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import ccConfig from '../../../config/carriercontact.locale';
import CarrierContactList from './CarrierContactList/CarrierContactList';

import styles from './CarrierContact.scss';

function CarrierContact(props) {
    const {
        t,
        longFormContent,
        regionalData,
        regionNames,
    } = props;

    return (
        <div aria-labelledby="header-title">
            <PageSection className={styles.header}>
                <PageTitle id="header-title">
                    {t('widgetTitle')}
                </PageTitle>
            </PageSection>
            {!!longFormContent.sections.length && (
                <LongFormContent
                    {...longFormContent}
                    namespace={ccConfig.namespace}
                    useSEOStyles
                />
            )}
            {!!regionNames.length && !!regionalData.length && (
                <CarrierContactList
                    regionNames={regionNames}
                    regionalData={regionalData}
                />
            )}
        </div>
    );
}

CarrierContact.propTypes = {
    longFormContent: PropTypes.shape({
        intro: PropTypes.string,
        sections: PropTypes.arrayOf(PropTypes.object),
        shortcuts: PropTypes.arrayOf(PropTypes.object),
    }),
    regionNames: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        id: PropTypes.string,
        isHidden: PropTypes.bool,
    })),
    regionalData: PropTypes.arrayOf(
        PropTypes.shape({
            contact_country_code: PropTypes.string,
            country_name: PropTypes.string,
            carrier_contacts: PropTypes.arrayOf(PropTypes.object),
        }),
    ),
};
CarrierContact.defaultProps = {
    longFormContent: {
        intro: '',
        sections: [],
        shortcuts: [],
    },
    regionalData: [],
    regionNames: [],
};

export { CarrierContact };
export default localize(CarrierContact, ccConfig.namespace);
